import React from "react";

export default function Likert({ value, onChange }) {
  return (
    <div className="ss-likert" role="group" aria-label="Symptom severity">
      {[0, 1, 2, 3, 4, 5].map((n, idx) => (
        <button
          key={n}
          type="button"
          onClick={() => onChange(n)}
          className={`ss-likert__btn ${idx === 0 ? "is-first" : ""} ${idx === 5 ? "is-last" : ""} ${value === n ? "is-active" : ""}`}
          aria-pressed={value === n}
          title={`${n} - ${n === 0 ? "Never" : n === 5 ? "Severe" : ""}`}
        >
          <span className="ss-likert__num">{n}</span>
          <span className="ss-likert__dot" aria-hidden="true"></span>
        </button>
      ))}
    </div>
  );
}


